export default __webpack_public_path__ + "right-chevron.png";